import { useRef, useState } from "react";

export default function CreditMonthPicker({ value, max, onChange }) {
  const [year, setYear] = useState(Number(value.slice(0, 4)));
  const disclosure = useRef(null);
  const min = "2020-01";
  const shift = delta => {
    const date = new Date(`${value}-01T00:00:00Z`);
    date.setUTCMonth(date.getUTCMonth() + delta);
    const next = date.toISOString().slice(0, 7);
    if (next >= min && next <= max) choose(next);
  };
  const choose = next => {
    onChange(next);
    setYear(Number(next.slice(0, 4)));
    if (disclosure.current) disclosure.current.open = false;
  };
  const label = new Date(`${value}-01T00:00:00Z`).toLocaleDateString(undefined, {month:"long", year:"numeric", timeZone:"UTC"});
  return <div className="credit-month-navigation" aria-label="Usage month">
    <button type="button" aria-label="Previous month" disabled={value <= min} onClick={() => shift(-1)}>‹</button>
    <details ref={disclosure} className="credit-month-disclosure" onToggle={e => {if (e.currentTarget.open) setYear(Number(value.slice(0,4)));}}>
      <summary>{label}<span aria-hidden="true">⌄</span></summary>
      <div className="credit-month-calendar">
        <label>Year <select aria-label="Usage year" value={year} onChange={e => setYear(Number(e.target.value))}>
          {Array.from({length:Number(max.slice(0,4))-2019}, (_,i) => Number(max.slice(0,4))-i).map(y => <option key={y}>{y}</option>)}
        </select></label>
        <div className="credit-month-grid">
          {Array.from({length:12}, (_,i) => {
            const month = `${year}-${String(i+1).padStart(2,"0")}`;
            const date = new Date(`${month}-01T00:00:00Z`);
            return <button key={month} type="button" disabled={month > max} aria-pressed={month === value} aria-label={date.toLocaleDateString(undefined,{month:"long",year:"numeric",timeZone:"UTC"})} onClick={() => choose(month)}>{date.toLocaleDateString(undefined,{month:"short",timeZone:"UTC"})}</button>;
          })}
        </div>
      </div>
    </details>
    <button type="button" aria-label="Next month" disabled={value >= max} onClick={() => shift(1)}>›</button>
    {value !== max && <button type="button" className="credit-month-today" onClick={() => choose(max)}>This month</button>}
  </div>;
}
